A personal summary provided by the candidate.

This is only available for Apply with SEEK candidate profiles.
For candidate applications, uploaded candidate profiles & purchased profiles this will be `null`.
